import React, { FC, memo } from 'react';

import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';
import { DeviceTypesInFlow } from 'application/components/common/SelectPlayerFlow/types';

import PointAddressItem from './PointAddressItem';

interface PointAddressesListProps {
  selectedPoints: {
    id: PointsListCheckboxGroupPointType['id'];
    address?: PointsListCheckboxGroupPointType['address'];
    title?: PointsListCheckboxGroupPointType['title'];
    device?: {
      type: DeviceTypesInFlow;
      requiredVersionUrl?: string;
    };
  }[];
}

const PointAddressesList: FC<PointAddressesListProps> = ({ selectedPoints }) => (
  <>
    {selectedPoints.length === 1 ? (
      <PointAddressItem
        key={selectedPoints[0].id}
        id={selectedPoints[0].id}
        address={selectedPoints[0].address}
        title={selectedPoints[0].title}
      />
    ) : (
      selectedPoints.map((point) => (
        <PointAddressItem
          key={point.id}
          id={point.id}
          address={point.address}
          title={point.title}
          withDevice={!!point.device?.type}
        />
      ))
    )}
  </>
);

export default memo(PointAddressesList);
